import {
    COMMON_FEEDBACK_USERFORM_RESET,
    COMMON_FORMAT_USERFORM_RESET,
    COMMON_PROPERTY_USERFORM_RESET,
    COMMON_STYLE_USERFORM_RESET,
    CREATE_COMMON_FEEDBACK_FAILURE,
    CREATE_COMMON_FEEDBACK_FORM,
    CREATE_COMMON_FEEDBACK_REQUEST,
    CREATE_COMMON_FEEDBACK_SUCCESS,
    CREATE_COMMON_FORMAT_FAILURE,
    CREATE_COMMON_FORMAT_REQUEST,
    CREATE_COMMON_FORMAT_SUCCESS,
    CREATE_COMMON_PROPERTY_FAILURE,
    CREATE_COMMON_PROPERTY_REQUEST,
    CREATE_COMMON_PROPERTY_SUCCESS,
    CREATE_COMMON_STYLE_FAILURE,
    CREATE_COMMON_STYLE_REQUEST,
    CREATE_COMMON_STYLE_SUCCESS,
    CREATE_USER_FORM_COMMON_FORMAT,
    CREATE_USER_FORM_COMMON_PROPERTY,
    CREATE_USER_FORM_COMMON_STYLE,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS,
    FETCH_COMMON_PROPERTY_BY_ID_FAILURE,
    FETCH_COMMON_PROPERTY_BY_ID_REQUEST,
    FETCH_COMMON_PROPERTY_BY_ID_SUCCESS,
    SET_SINGLE_ROW_CLICK_ID,
    COMMON_APPROVALMAIL_USERFORM,
    APP_LOGOUT_REQUEST,
    APP_LOGOUT_SUCCESS,
    APP_LOGOUT_FAILURE,
    APP_FORCE_LOGOUT_REQUEST,
    APP_FORCE_LOGOUT_SUCCESS,
    APP_FORCE_LOGOUT_FAILURE,
    SET_FORCE_LOGOUT_VAR
} from './commonProperty.actionsType';
import ConstantApi from '../../../ConstantApi';
import axiosCall from '../../axiosCall';
import Config from '../../../config';
import axios from 'axios';
import Cookies from 'js-cookie';

// CREATE PROPERTY
export let createCommonProperty = (formData, modalClose, api, modalId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldFKProperty: parseInt(formData.propertySelect),
        fldSlNo: parseInt(formData.slno),
        fldDescription: formData.description,
        fldShortName: formData.sdescription,
        fldSetAsDefault: formData.check,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.propertyPOST}`,
        responseTypeRequest: CREATE_COMMON_PROPERTY_REQUEST,
        responseTypeSuccess: CREATE_COMMON_PROPERTY_SUCCESS,
        responseTypeFailure: CREATE_COMMON_PROPERTY_FAILURE,
        resetFormData: COMMON_PROPERTY_USERFORM_RESET,
        propertyModal: modalClose,
        modalId: modalId,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: api
    };
    return axiosCall(config);
};

export let createCommonStyle = (formData, modalClose, api, modalId) => {
    let config = {
        method: 'post',
        url: `${ConstantApi.stylePOST}${formData?.fldStyleName}`,
        responseTypeRequest: CREATE_COMMON_STYLE_REQUEST,
        responseTypeSuccess: CREATE_COMMON_STYLE_SUCCESS,
        responseTypeFailure: CREATE_COMMON_STYLE_FAILURE,
        resetFormData: COMMON_STYLE_USERFORM_RESET,
        styleModal: modalClose,
        modalId: modalId,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: api
    };
    return axiosCall(config);
};

export let createCommonFormat = (formData, modalClose, api, modalId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    let config = {
        method: 'post',
        url: `${ConstantApi.formatPOST}`,
        responseTypeRequest: CREATE_COMMON_FORMAT_REQUEST,
        responseTypeSuccess: CREATE_COMMON_FORMAT_SUCCESS,
        responseTypeFailure: CREATE_COMMON_FORMAT_FAILURE,
        resetFormData: COMMON_FORMAT_USERFORM_RESET,
        formatModal: modalClose,
        modalId: modalId,
        data,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: api
    };
    return axiosCall(config);
};

export let fetchCommonPropertyById = (codeId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${codeId}`,
        responseTypeRequest: FETCH_COMMON_PROPERTY_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_COMMON_PROPERTY_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_COMMON_PROPERTY_BY_ID_FAILURE,
        payload: codeId
    };
    return axiosCall(config);
};

export let fetchAnyOfCommonPropertyById = (codeId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${codeId}`,
        responseTypeRequest: FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE,
        payload: codeId
    };
    return axiosCall(config);
};

export let createCommonPropertyUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMMON_PROPERTY, payload: { key, value } });
    };
};

export let createCommonStyleUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMMON_STYLE, payload: { key, value } });
    };
};

export let createCommonFormatUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMMON_FORMAT, payload: { key, value } });
    };
};

export let setSingleRowClickData = (value) => {
    return (dispatch) => {
        dispatch({ type: SET_SINGLE_ROW_CLICK_ID, payload: value });
    };
};

// CREATE FEEDBACK
export let createCommonFeedback = (formData, modalClose, modalId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldFKStatus: parseInt(formData.fldFKStatus),
        fldFKType: parseInt(formData.fldFKType)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.feedbackAnyWherePOST}`,
        responseTypeRequest: CREATE_COMMON_FEEDBACK_REQUEST,
        responseTypeSuccess: CREATE_COMMON_FEEDBACK_SUCCESS,
        responseTypeFailure: CREATE_COMMON_FEEDBACK_FAILURE,
        resetFormData: COMMON_FEEDBACK_USERFORM_RESET,
        feedbackModalClose: modalClose,
        modalId: modalId,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export let createCommonFeedbackForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_COMMON_FEEDBACK_FORM, payload: { key, value } });
    };
};

export let SendApprovalOTPMail = (arrayData) => {
    let config = {
        method: 'post',
        data: arrayData,
        url: `${ConstantApi.sendApprovalOTPPOST}`,
        responseTypeRequest: COMMON_APPROVALMAIL_USERFORM,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export let appLogout = () => {
    return (dispatch) => {
        dispatch({ type: APP_LOGOUT_REQUEST });
        var config = {
            method: 'post',
            url: `${Config.baseUrl}${ConstantApi.appLogoutPOST}?pUserLoginID=${Cookies.get('USERID')}&FldFKUser=${Cookies.get('FKUser')}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: APP_LOGOUT_SUCCESS, payload: response.data });
                Cookies.remove('JWT_TOKEN');
                Cookies.remove('USER');
                Cookies.remove('DATABASE');
                Cookies.remove('USERID');
                Cookies.remove('PASSWORD');
                Cookies.remove('URL');
                // localStorage.clear();

                const keyToKeep = 'fromBoxes';
                const valueToKeep = localStorage.getItem(keyToKeep);

                // Clear all localStorage
                localStorage.clear();

                // Restore the key you want to keep
                if (valueToKeep !== null) {
                    localStorage.setItem(keyToKeep, valueToKeep);
                }
                window.location.reload();
                window.location.replace(
                    window?.location?.href?.split('#')[0].substring(0, window?.location?.href?.split('#')[0].length - 1)
                );
            })
            .catch((error) => {
                dispatch({ type: APP_LOGOUT_FAILURE, payload: error });
            });
    };
};

export let appForceLogout = () => {
    return (dispatch) => {
        dispatch({ type: APP_FORCE_LOGOUT_REQUEST });
        var config = {
            method: 'post',
            url: `${Config.baseUrl}${ConstantApi.appForceLogoutPOST}?pUserLoginID=${Cookies.get('USERID')}&pPassword=${Cookies.get(
                'PASSWORD'
            )}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: APP_FORCE_LOGOUT_SUCCESS, payload: response.data });
                dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });
                Cookies.remove('JWT_TOKEN');
                Cookies.remove('USER');
                Cookies.remove('DATABASE');
                Cookies.remove('USERID');
                Cookies.remove('PASSWORD');
                Cookies.remove('URL');
                window.location.reload();
                window.location.replace('/');
            })
            .catch((error) => {
                dispatch({ type: APP_FORCE_LOGOUT_FAILURE, payload: error });
            });
    };
};
